import { DAY_LOWERCASE, DAY_TRUNCATED } from '../constants';

const truncateLowercaseDay = (day: DAY_LOWERCASE): DAY_TRUNCATED => {
  switch (day) {
    case DAY_LOWERCASE.MONDAY:
      return DAY_TRUNCATED.MON;
    case DAY_LOWERCASE.TUESDAY:
      return DAY_TRUNCATED.TUE;
    case DAY_LOWERCASE.WEDNESDAY:
      return DAY_TRUNCATED.WED;
    case DAY_LOWERCASE.THURSDAY:
      return DAY_TRUNCATED.THU;
    case DAY_LOWERCASE.FRIDAY:
      return DAY_TRUNCATED.FRI;
    case DAY_LOWERCASE.SATURDAY:
      return DAY_TRUNCATED.SAT;
    case DAY_LOWERCASE.SUNDAY:
      return DAY_TRUNCATED.SUN;
  }
};

export default truncateLowercaseDay;
